export function Logo({ light = false, size = "h-14 w-14" }) {
  return (
    <span className="flex items-center gap-3">
      <img
        src="/img/logo-96.webp"
        srcSet="/img/logo-96.webp 96w, /img/logo-192.webp 192w"
        sizes="56px"
        width="56"
        height="56"
        alt="Lucky Taxi Service logo"
        className={`${size} shrink-0 rounded-full bg-white object-contain ring-1 ring-line`}
        fetchpriority="high"
      />
      <span className="whitespace-nowrap leading-none">
        <span className={`block font-display text-[22px] font-bold tracking-tight ${light ? "text-white" : "text-ink"}`}>Lucky Taxi</span>
        <span className={`block text-[9.5px] font-semibold uppercase tracking-[0.2em] ${light ? "text-gold" : "text-saffron"}`}>Service · Rajasthan</span>
      </span>
    </span>
  );
}
